import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash';

export const AppSlice = createSlice({
  name: "app",
  initialState: {
    orderDashboard: {
      filteredTaskId: 0
    },
    pageName: '',
    onboardingStep: 0
  },
  reducers: {
    setPageName: (state, action) => {
      state.pageName = action.payload;
    },
    setFilteredTaskId: (state, action) => {
      state.orderDashboard.filteredTaskId = action.payload;
    },
    setOnboardingStep: (state, action) => {
      state.onboardingStep = action.payload;
    }
  }
});
export const { setFilteredTaskId, setPageName, setOnboardingStep } = AppSlice.actions;
export default AppSlice.reducer;